import { Helmet } from 'react-helmet-async';



import { Button, Container, Grid } from '@mui/material';
import ContractorCalendarData from './contractorCalenderData';






function ContractorCalender() {
  return (
    <>
      <Helmet>
        <title>Contractor - ContractorCalender</title>
      </Helmet>
      {/* <PageTitleWrapper>
        < JobsHeader/>
      </PageTitleWrapper> */}
      {/* <Container> */}
        <Grid
          // container
          // direction="row"
          // justifyContent="center"
          // alignItems="stretch"
          // spacing={3}
         
        >
         
          <Grid item xs={12}>
            <ContractorCalendarData/>
          </Grid>
        </Grid>
      {/* </Container> */}
      {/* <Footer /> */}
    </>
  );
}

export default ContractorCalender;
